import React from 'react';
import CmsContent from '../../CmsContent';
import styles from './SplashHeader.less';

var SplashHeader = function SplashHeader(_ref) {
  var pageHeader = _ref.nav_page_header,
      displayHeader = _ref.page_header_display;
  return displayHeader && pageHeader ? /*#__PURE__*/React.createElement("h1", {
    className: styles['splash-header']
  }, /*#__PURE__*/React.createElement(CmsContent, {
    content: pageHeader
  })) : null;
};

export default SplashHeader;